import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import './UserProfile.css';

export default function UserProfile() {
  const { instance, accounts } = useMsal();
  const [user, setUser] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      setUser(accounts[0]);
    }
  }, [accounts]);

  const handleLogout = () => {
    instance.logoutPopup({
      postLogoutRedirectUri: '/'
    });
  };

  if (!user) {
    return null;
  }

  const displayName = user.name || user.username || 'User';
  const initials = displayName
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);

  return (
    <div className="user-profile">
      <div className="user-menu-trigger" onClick={() => setShowMenu(!showMenu)}>
        <div className="user-avatar">{initials}</div>
        <span className="user-name">{displayName}</span>
        <span className="dropdown-arrow">▼</span>
      </div>

      {showMenu && (
        <div className="user-dropdown-menu">
          <div className="menu-header">
            <div className="menu-avatar">{initials}</div>
            <div className="menu-info">
              <div className="menu-name">{displayName}</div>
              <div className="menu-email">{user.username}</div>
            </div>
          </div>

          <div className="menu-divider"></div>

          <button
            className="menu-item logout-item"
            onClick={handleLogout}
          >
            <span>🚪</span>
            <span>Sign out</span>
          </button>
        </div>
      )}

      {/* Overlay to close menu when clicking outside */}
      {showMenu && (
        <div
          className="menu-overlay"
          onClick={() => setShowMenu(false)}
        ></div>
      )}
    </div>
  );
}
